"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  t = require("react"),
  a = require("prop-types"),
  n = require("styled-components"),
  r = require("./colors-c0f39aa2.js"),
  l = require("./grid-965d799c.js"),
  i = require("./typography-fb2881fe.js"),
  o = require("./taggedTemplateLiteral-97b463ad.js"),
  d = require("polished/lib/helpers/rem"),
  g = require("./link-8b1ebef7.js"),
  u = require("./foundations/Icon/icons/utility/ArrowRight.js.js");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var c,
  p,
  f,
  m,
  h,
  b,
  k,
  T,
  L,
  y,
  v,
  _,
  w,
  E,
  x,
  C,
  D,
  O,
  q,
  R,
  j,
  U,
  V,
  A,
  S,
  z,
  N,
  W,
  B,
  F = s(t),
  I = s(a),
  P = s(n),
  G = s(d),
  H = P["default"].a(c || (c = o._taggedTemplateLiteral(["\n  text-decoration: none;\n  &:hover {\n    text-decoration: none;\n  }\n"]))),
  J = P["default"].article(p || (p = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.backgroundVariant,
      r = e.themeType,
      l = t.colors.background.lightTheme.lightA;
    return "lightTheme" === r && ("lightB" === a ? l = t.colors.background.lightTheme.lightB : "lightC" === a ? l = t.colors.background.lightTheme.lightC : "lightSky" === a && (l = t.colors.background.lightTheme.lightSky)), "darkTheme" === r && "darkDefault" === a && (l = t.colors.background.darkTheme.darkDefault), n.css(f || (f = o._taggedTemplateLiteral(["\n    position: relative;\n    background-color: ", ";\n  "])), l);
  }),
  K = P["default"].button(m || (m = o._taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  &:hover {\n    cursor: pointer;\n  }\n"]))),
  M = P["default"](l.Col)(h || (h = o._taggedTemplateLiteral(["\n  margin: auto;\n"]))),
  Q = P["default"](l.Col)(b || (b = o._taggedTemplateLiteral(["\n  margin: 0;\n"]))),
  X = P["default"].div(k || (k = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.image,
      r = e.imageWebp,
      l = t.smallUp();
    return n.css(T || (T = o._taggedTemplateLiteral(["\n      min-height: ", ";\n      height: 100%;\n      width: 100%;\n      /* if webp is not supported, fall back to the default image */\n      background-image: url(", ");\n      /* browsers that support the gap property and ones that support the webp property are nearly identical */\n      /* If the imageWebp prop is passed in, display that, otherwise we fall back to the default image */\n      ", "\n      background-size: cover;\n      background-position: center;\n    "])), l ? G["default"](265) : G["default"](175), a, r && "\n        @supports (gap: 1px) {\n          background-image: url(".concat(r, ");\n        }\n      "));
  }),
  Y = P["default"].div(L || (L = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.image,
      r = e.imageWebp,
      l = t.mediumUp();
    return n.css(y || (y = o._taggedTemplateLiteral(["\n      height: ", ";\n      width: 100%;\n      background-size: cover;\n      background-position: center;\n      /* if webp is not supported, fall back to the default image */\n      background-image: url(", ");\n      /* browsers that support the gap property and ones that support the webp property are nearly identical */\n      /* If the imageWebp prop is passed in, display that, otherwise we fall back to the default image */\n      ", "\n    "])), l ? G["default"](200) : G["default"](160), a, r && "\n        @supports (gap: 1px) {\n          background-image: url(".concat(r, ");\n        }\n      "));
  }),
  Z = P["default"].div(v || (v = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.largeUp(),
      a = G["default"](32);
    return t && (a = "".concat(G["default"](32), " ").concat(G["default"](64))), n.css(_ || (_ = o._taggedTemplateLiteral(["\n      align-items: center;\n      text-align: center;\n      height: 100%;\n      padding: ", ";\n    "])), a);
  }),
  $ = P["default"].div(w || (w = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return n.css(E || (E = o._taggedTemplateLiteral(["\n    background-color: ", ";\n    overflow: hidden;\n    transition: ", ";\n    margin: 0 0 ", ";\n    position: relative;\n    &:hover {\n      box-shadow: ", ";\n      text-decoration: none;\n    }\n  "])), t.colors.neutral.grayLight30, t.effects.shadows.transition, G["default"](32), t.effects.shadows.hover);
  }),
  ee = P["default"].div(x || (x = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return n.css(C || (C = o._taggedTemplateLiteral(["\n    overflow: hidden;\n    transition: ", ";\n    margin: 0 0 ", ";\n    position: relative;\n    overflow: visible;\n    &:hover {\n      box-shadow: ", ";\n      text-decoration: none;\n    }\n  "])), t.effects.shadows.transition, G["default"](32), t.effects.shadows.hover);
  }),
  te = P["default"].div(D || (D = o._taggedTemplateLiteral(["\n  flex-direction: column;\n  padding: ", ";\n"])), G["default"](24)),
  ae = P["default"](u)(O || (O = o._taggedTemplateLiteral(["\n  margin-left: ", ";\n  margin-bottom: ", ";\n"])), G["default"](8), G["default"](1)),
  ne = P["default"](g.LinkComponent)(q || (q = o._taggedTemplateLiteral(["\n  margin-top: ", ";\n  text-transform: none;\n"])), G["default"](16)),
  re = P["default"].span(R || (R = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.flagColor;
    return n.css(j || (j = o._taggedTemplateLiteral(["\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    display: inline-flex;\n    height: ", ";\n    align-items: center;\n    padding: ", ";\n    background-color: ", ";\n    z-index: 1;\n    border-radius: 0 0 1px 0;\n    ::after {\n      position: absolute;\n      top: 0;\n      right: ", ";\n      border-bottom: ", " solid transparent;\n      border-left: ", " solid ", ";\n      content: '';\n      @media print {\n        display: none;\n      }\n    }\n  "])), G["default"](8), G["default"](-8), G["default"](25), G["default"](13), t, G["default"](-12), G["default"](26), G["default"](12), t);
  }),
  le = P["default"](i.TypographyComponent)(U || (U = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.branding,
      r = 500,
      l = t.colors.neutral.black;
    return "pcg" === a && (r = 300, l = t.colors.neutral.greyDark3), n.css(V || (V = o._taggedTemplateLiteral(["\n      && {\n        color: ", ";\n        font-size: ", ";\n        text-transform: uppercase;\n        letter-spacing: ", ";\n        margin-top: ", ";\n        font-weight: ", ";\n      }\n    "])), l, G["default"](14), G["default"](2.5), G["default"](2), r);
  }),
  ie = P["default"](i.TypographyComponent)(A || (A = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      a = e.theme,
      r = e.hasLink,
      l = e.branding,
      i = e.backgroundVariant,
      d = 500;
    return t = a.mediumUp() ? G["default"](64) : G["default"](48), "pcg" === l && (d = 300), n.css(S || (S = o._taggedTemplateLiteral(["\n      && {\n        padding-bottom:", ";\n        font-weight: ", ";\n        ", "\n      }\n    "])), r ? t : 0, d, "darkDefault" === i && "color: ".concat(a.colors.neutral.white, ";"));
  }),
  oe = P["default"](i.TypographyComponent)(z || (z = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      a = e.backgroundVariant;
    return n.css(N || (N = o._taggedTemplateLiteral(["\n    display: block;\n    ", "\n  "])), "darkDefault" === a && "color: ".concat(t.colors.neutral.white, ";"));
  }),
  de = P["default"](i.TypographyComponent)(W || (W = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.backgroundVariant;
    return n.css(B || (B = o._taggedTemplateLiteral(["\n    position: absolute;\n    bottom: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n  "])), G["default"](16), G["default"](4), "darkDefault" === a ? t.colors.action.darkTheme.linkDefault : t.colors.action.lightTheme.linkDefault);
  }),
  ge = function ge(t) {
    var a,
      n = t.actionId,
      o = t.assistiveText,
      d = t.backgroundVariant,
      g = t.branding,
      u = t.buttonText,
      s = t.className,
      c = t.disableLazyLoad,
      p = t.flag,
      f = t.image,
      m = t.imageWebp,
      h = t.isOutgoingLink,
      b = t.metadata,
      k = t.orientation,
      T = t.tag,
      L = t.themeType,
      y = t.title,
      v = t.url,
      _ = t.visualLink,
      w = r.DEFAULT_COLORS.sky.sky,
      E = r.DEFAULT_COLORS.gold.gold,
      x = r.DEFAULT_COLORS.brand.pcg.gold2;
    return a = "pcg" === p || "pcg" === g ? x : "secondary" === p ? E : w, "card" === k ? F["default"].createElement(ee, {
      className: s
    }, F["default"].createElement(J, {
      backgroundVariant: d,
      themeType: L
    }, F["default"].createElement(H, e._extends({
      href: v,
      id: n,
      "data-tracking-id": n,
      ariaLabel: o
    }, h && {
      target: "_blank",
      rel: "nofollow noopener noreferrer"
    }), F["default"].createElement(re, {
      flagColor: a
    }, F["default"].createElement(le, {
      weight: 500,
      branding: g,
      disableBottomPadding: !0
    }, T)), F["default"].createElement(Y, {
      image: f,
      imageWebp: m,
      className: "".concat(!c && "lazy")
    }), F["default"].createElement(te, {
      className: "js-dynamic-callout-card-content-container"
    }, !!b && F["default"].createElement(oe, {
      className: "nmx-no-print",
      backgroundVariant: d,
      component: "time",
      variant: "h6",
      color: r.DEFAULT_COLORS.neutral.grayDark10,
      weight: 300,
      branding: g,
      uppercase: !0
    }, b), F["default"].createElement(ie, {
      component: "h3",
      variant: "h4",
      backgroundVariant: d,
      color: r.DEFAULT_COLORS.neutral.grayDark20,
      branding: g,
      hasLink: _
    }, y), !!_ && F["default"].createElement(de, {
      className: "nmx-no-print",
      weight: 500,
      backgroundVariant: d,
      disableBottomPadding: !0
    }, _, F["default"].createElement(ae, null)))))) : F["default"].createElement($, {
      className: s
    }, F["default"].createElement(l.Row, {
      align: "center"
    }, F["default"].createElement(Q, {
      small: 5,
      medium: 6,
      large: 5,
      nested: !0
    }, F["default"].createElement(X, {
      image: f,
      imageWebp: m,
      className: "".concat(!c && "lazy")
    })), F["default"].createElement(M, {
      small: 7,
      medium: 6,
      large: 7
    }, F["default"].createElement(Z, null, F["default"].createElement(i.TypographyComponent, {
      component: "h2",
      variant: "h3",
      branding: g,
      color: r.DEFAULT_COLORS.neutral.grayDark20,
      disableBottomPadding: !0
    }, y), F["default"].createElement(ne, {
      role: "link",
      variant: "buttonLinkSecondary",
      id: "".concat(n, "-button"),
      "data-tracking-id": "".concat(n, "-button"),
      ariaLabel: o,
      linkUrl: v
    }, u || "Get started")))), F["default"].createElement(K, {
      role: "link",
      id: n,
      "data-tracking-id": n,
      "aria-label": o,
      onClick: function onClick() {
        var e;
        e = v, window.location.href = e;
      }
    }));
  };
ge.propTypes = {
  actionId: I["default"].string.isRequired,
  assistiveText: I["default"].string,
  backgroundVariant: I["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC", "lightSky"]),
  branding: I["default"].oneOf(["nm", "pcg"]),
  buttonText: I["default"].string,
  className: I["default"].string,
  disableLazyLoad: I["default"].bool,
  flag: I["default"].string,
  image: I["default"].string.isRequired,
  imageWebp: I["default"].string,
  metadata: I["default"].string,
  orientation: I["default"].string,
  isOutgoingLink: I["default"].bool,
  tag: I["default"].string,
  themeType: I["default"].oneOf(["lightTheme", "darkTheme"]),
  title: I["default"].oneOfType([I["default"].object, I["default"].string]).isRequired,
  url: I["default"].string.isRequired,
  visualLink: I["default"].string
}, ge.defaultProps = {
  disableLazyLoad: !1,
  branding: "nm",
  backgroundVariant: "lightA",
  themeType: "lightTheme"
};
var ue = n.withTheme(ge);
exports.DynamicCallout = ue;